import styled from '@emotion/styled/macro';
import rem from '../../utils/rem/rem';
import { Container } from '../Checkbox/Checkbox.styles';
import { StyledProps } from './TreeView.types';

export const StyledTreeViewContainer = styled.div<StyledProps>`
  border: 1px solid ${({ theme }) => theme.colors.gray400};
  border-radius: ${({ borderRadius }) => `${borderRadius === undefined ? 8 : borderRadius}px`};
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: 100%;

  div:nth-of-type(odd):not(${Container}) {
    background-color: ${({ theme }) => theme.colors.white};

    &:hover {
      background-color: ${({ theme }) => theme.colors.blueOpacity10};
    }
  }
`;

export const Row = styled.div<StyledProps>`
  display: flex;
  height: ${rem(50)};
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: ${rem(16)} 0;
  padding-left: ${({ level }) => `${level === 1 || level === undefined ? 8 : (level - 1) * 68}px`};
  border-bottom: 1px solid ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.gray100};
  label: treeViewRow;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.blueOpacity10};
  }

  &:focus {
    outline: 1px solid ${({ theme }) => theme.colors.blue};
    outline-offset: -1px;
  }

  a {
    display: inline;
  }
`;

export const RowLabel = styled.label<StyledProps>`
  font-family: 'Open Sans';
  font-weight: ${({ expanded }) => (expanded ? 700 : 400)};
  font-size: ${rem(14)};
  color: ${({ theme }) => theme.colors.gray900};
`;
